/*生产环境*/
const host = 'https://wuye.youmeijia.net/';
const baseImg = "http://image.h5.wuye.youmeijia.net/";
const imgUrl = 'http://wuye.youmeijia.net';


/*生产环境(耀客松)*/
// const host = 'http://wuye.yaokesong.com:12356/';
// const baseImg = "http://wuye.yaokesong.com/";
// const imgUrl = 'http://wuye.yaokesong.com';

/*开发环境*/
// const host = 'http://192.168.1.100:12354/';
// const baseImg = 'http://192.168.1.100:8081/';
// const imgUrl = 'http://sq.datamavin.cn';

/*测试环境*/
// const host = 'http://114.116.27.40:12354/';
// const baseImg = "http://114.116.27.40:12364/images/";

//本地数据
// const host = 'http://youmeijia.ngrok.xiaomiqiu.cn/';
// const host = 'http://192.168.1.100:12354/';
// const baseImg = "http://images.ngrok.xiaomiqiu.cn/";

const SMSHost = 'http://120.78.69.176:12353/';

/*生产环境*/
const wechat = {
  corpid:'wx3921ae84c7b2fd56',
  corpsecret:'d44a75efa20443927e546393a7154dd7'
}

/*生产环境(耀客松)*/
// const wechat = {
//   corpid:'wx7c7073559f0c012e',
//   corpsecret:'cc45927ba99a6842b4e2653477e2f47d'
// }

/*测试环境*/
// const wechat = {
//    corpid:'wxf425aaf70ac87365',
//    corpsecret:'222c3245ca976cf6df8bb24070483035'
// }

const dingding = {
	corpid:'ding4d93dde8c21f381e35c2f4657eb6378f',
	corpsecret:'0Q1wnX39_i9hWMYrZlQp3IxZrobkHlJp3xGXhQye5Xh9MinJP9UzAFAGZp7R4gs6'
}

export default{
  host,
  wechat,
  dingding,
  SMSHost,
  imgUrl,
  baseImg
}



// WEBPACK FOOTER //
// ./static/js/global.js